export const REFERRAL_VALUES = {
  INVITATION_SENT: 'Invitation sent',
  ENROLLED: 'Enrolled',
  REWARD_EARNED: 'Reward earned',
  CARD_LINKED: 'Card linked',
  CARD_USED: 'Card used',
};
